<template>
  <v-menu offset-y close-on-click>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        height="50px"
        color="primary"
        text
        v-bind="attrs"
        class="px-8"
        v-on="on"
      >
        <span class="font_tabs btn" v-text="$t('sections.stores')" />
      </v-btn>
    </template>
    <v-list>
      <!-- <v-list-item
        v-for="(item, index) in stores"
        :key="index"
        @click="selectStore(item)"
      > -->
      <v-list-item
        v-for="(item, index) in stores"
        :key="index"
        @click="
          $router.push({
            name: 'Discovery',
            params: { id: item.slug },
          })
        "
      >
        <v-list-item-content>
          <v-list-item-title v-text="item.storeName" />
          <v-list-item-subtitle v-text="item.storeAddress" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "MenuStores",
  computed: {
    stores: {
      get() {
        return this.$store.getters.appStoresList;
      },
      set(val) {
        return val;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.font_tabs {
  font-family: $font_Regular;
  font-size: 1.2rem;
  color: #000;
}

.link-active .font_tabs {
  color: var(--v-primary-base) !important;
}
</style>
